module.exports = __webpack_public_path__ + "img/saum_anthrazitgrau_ral7016.c7b5a7f8.jpg";